import axios from "axios";

export function configurationsAPI(merchant_id, domain) {
  const params = {};
  if (merchant_id) params.mid = merchant_id;
  if (domain) params.sd = domain;

  return axios.get(
    `${process.env.REACT_APP_API_DOMAIN}/api/site-widget/modal/config/`,
    { params }
  );
}

export function searchOrders(settings, email, phonenumber, token, order_name) {
  let host = settings?.rms_api_host?.replace("/v1", "/v2") || settings.rms_api_host;
  return axios.get(`${host}/orders`, {
    params: {
      phonenumber,
      merchant_id: settings.merchant.id,
      email,
      offset: 0,
      limit: 50,
      order_name,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function fetchPublicOrders(settings, phone, email, order_name) {
  let host = settings?.rms_api_host?.replace("/v1", "/v2") || settings.rms_api_host;
  return axios.get(`${host}/public/orders`, {
    params: {
      phone, email, offset: 0, limit: 50, order_name
    },
    headers: {
      public_api_key: settings.merchant.public_api_key
    }
  })
}

export function getMid(settings) {
  return axios.get(
    `${settings.rms_api_host}/get/encrypted/merchant_id?mid=${settings.merchant.id}`
  );
}

export function trackOrderApi(order_id, merchant_id) {
  return axios.get(
    `${process.env.REACT_APP_API_DOMAIN}/api/site-widget/order-tracking/?mid=${merchant_id}&oid=${order_id}`
  );
}

export function getHelpArticles(merchant_id) {
  return axios.get(
    `${process.env.REACT_APP_API_DOMAIN}/api/site-widget/help-center/${merchant_id}/articles/search/`
  );
}

export function generateOTPApi(contact, merchant, otp_settings) {
  return axios.post(
    `${process.env.REACT_APP_AUTH_API_HOST}/api/v1/otp/generate`,
    {
      contact,
      merchant,
      otp_settings,
    }
  );
}

export function verifyOtpApi(contact, merchant_id, otp) {
  return axios.post(
    `${process.env.REACT_APP_AUTH_API_HOST}/api/v1/otp/verify`,
    {
      contact,
      merchant_id,
      otp,
    }
  );
}

export function faqSearch(searchTerm, merchant_id) {
  return axios.get(
    `${process.env.REACT_APP_API_DOMAIN}/api/site-widget/help-center/${merchant_id}/articles/search/`,
    {
      params: {
        q: searchTerm,
      },
    }
  );
}

export function contactUsApi(
  merchant_id,
  full_name,
  email,
  phone_number,
  query_reason,
  message
) {
  return axios.post(
    `${process.env.REACT_APP_API_DOMAIN}/api/site-widget/${merchant_id}/customer-query/`,
    {
      merchant: merchant_id,
      full_name,
      email,
      phone_number,
      query_reason,
      message,
    }
  );
}

export function npsSubmitApi(
  merchant_id,
  order,
  net_promoter_score,
  nps_comment
) {
  return axios.post(
    `${process.env.REACT_APP_API_DOMAIN}/api/merchants/nps/submit/`,
    {
      mid: merchant_id,
      order,
      net_promoter_score,
      nps_comment,
      nps_source: "website",
    }
  );
}
